'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _InfoCircleOutlined = _interopRequireDefault(require('./lib/icons/InfoCircleOutlined'));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _default = _InfoCircleOutlined;
exports.default = _default;
module.exports = _default;